import BudgetList from './BudgetList';

export default BudgetList;
